import React from "react";
import logo from "../../../assets/images/logos/576_Cash Canvas-02.png";

const LogoContainer = ({ className = "" }) => (
  <div className={`fixed top-0 left-0 p-4 ${className}`}>
    <img
      src={logo}
      alt="Cash Canvas Logo"
      className="h-20 w-auto object-contain max-w-[150px]"
    />
  </div>
);

export default LogoContainer;